(() => {
  const getAllOpenRoots = () => {
    const roots = [document];

    for (let index = 0; index < roots.length; index += 1) {
      const root = roots[index];
      root.querySelectorAll?.('*').forEach((node) => {
        if (node.shadowRoot && !roots.includes(node.shadowRoot)) roots.push(node.shadowRoot);
      });
    }

    return roots;
  };

  const findPositioningWrapper = (teaser) => {
    let current = teaser;

    while (current) {
      if (current instanceof Element) {
        const styles = getComputedStyle(current);
        if (styles.position === 'fixed' || styles.position === 'absolute') return current;
      }

      if (current.parentElement) {
        current = current.parentElement;
      } else {
        const root = current.getRootNode?.();
        current = root instanceof ShadowRoot ? root.host : null;
      }
    }

    return teaser;
  };

  const positionShopifyFormsTeaser = () => {
    getAllOpenRoots().forEach((root) => {
      root.querySelectorAll?.('[data-testid="form-teaser"]').forEach((teaser) => {
        const wrapper = findPositioningWrapper(teaser);

        wrapper.style.setProperty('top', 'auto', 'important');
        wrapper.style.setProperty('bottom', '75px', 'important');

        const transform = getComputedStyle(wrapper).transform;
        if (transform && transform !== 'none') {
          wrapper.style.setProperty('transform', 'none', 'important');
        }

        wrapper.dataset.petalTeaserPositioned = 'true';
      });
    });
  };

  const removeLegacyGiftOptions = () => {
    document.querySelectorAll('.petal-gift-options').forEach((element) => element.remove());
  };

  let queued = false;
  const enhance = () => {
    if (queued) return;
    queued = true;

    requestAnimationFrame(() => {
      queued = false;
      removeLegacyGiftOptions();
      positionShopifyFormsTeaser();
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', enhance, { once: true });
  } else {
    enhance();
  }

  document.addEventListener('shopify:section:load', enhance);
  window.addEventListener('resize', enhance, { passive: true });

  new MutationObserver(enhance).observe(document.documentElement, {
    childList: true,
    subtree: true,
    attributes: true,
    attributeFilter: ['style', 'class']
  });

  let attempts = 0;
  const timer = window.setInterval(() => {
    enhance();
    attempts += 1;
    if (attempts >= 60) window.clearInterval(timer);
  }, 500);
})();
